import { render, staticRenderFns } from "./UserStat.vue?vue&type=template&id=6154f891&scoped=true&"
import script from "./UserStat.vue?vue&type=script&lang=js&"
export * from "./UserStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6154f891",
  null
  
)

export default component.exports